var apiUrl = process.env.REACT_APP_BASE_API_URL
var baseAppUrl = process.env.REACT_APP_BASE_URL
var environment = process.env.NODE_ENV
const Defaults = {
    apiUrl: apiUrl,
    appUrl: baseAppUrl,
    environment: environment,
}

export {Defaults}